/* unplugin-vue-components disabled */import script from "./user_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./user_copy.vue?vue&type=script&setup=true&lang=js"

import "./user_copy.vue?vue&type=style&index=0&id=043bacd3&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043bacd3"]])

export default __exports__